import axios from '../../utils/axios';
import { objectToFormData } from '../utils';

// POST
// /Api/CostReport/AiUsage
export const postAiUsageReport = async (filters) => {
    const formData = objectToFormData(filters);
    const response = await axios.post('/CostReport/AiUsage', formData);
    return response;
};

// POST
// /Api/CostReport/AiUsageDownload
export const postAiUsageReportDownload = async (filters) => {
    const formData = objectToFormData(filters);
    const response = await axios.post('/CostReport/AiUsageDownload', formData, { responseType: 'blob' });
    return response;
};

// GET
// /Api/CostReport/AiUsageSites
export const getAiUsageSites = async () => {
    const response = await axios.get('/CostReport/AiUsageSites');
    return response.data;
};

// GET
// /Api/CostReport/CompaniesAndFacilitiesForReports
export const getCompaniesAndFacilitiesForReports = async () => {
    const response = await axios.get('/CostReport/CompaniesAndFacilitiesForReports');
    return response.data;
};

